import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
  dropdownButton: {
    padding: theme.spacing(1),
    '& .MuiTypography-button': {
      display: 'flex',
      justifyContent: 'space-between',
      columnGap: theme.spacing(1),
    },
    height: '32px',
    minWidth: 'fit-content',
  },
  dropdownButtonText: {
    color: theme.palette.primary.main,
    fontSize: '14px',
    fontWeight: 500,
  },
  icon: {
    float: 'right',
    height: '16px',
    width: '16px',
    alignSelf: 'center',
  },
}));

export default useStyles;
